function init_stat_counter()
{
    window.sc_project = 12673371; 
    window.sc_invisible = 1; 
    window.sc_security = "ce910324"; 
    
    var e = document.createElement('script');
    var n = document.getElementsByTagName('script')[0];
    e.type = 'text/javascript';
    e.async = true;
    e.src = 'https://www.statcounter.com/counter/counter.js';
    n.parentNode.insertBefore(e, n);
}

/* No Script Tag
<noscript><div class="statcounter"><a title="web statistics"
href="https://statcounter.com/" target="_blank"><img class="statcounter"
src="https://c.statcounter.com/12673371/0/ce910324/1/" alt="web statistics"
referrerPolicy="no-referrer-when-downgrade"></a></div></noscript> */

export default init_stat_counter;